import { createBrowserRouter, RouterProvider } from "react-router-dom";
import PageNotFound from "../pages/Errors/PageNotFound";
import AuthLayout from "../layouts/Auth";
import MainLayout from "../layouts/Main";
import Home from "../pages/Home";
import Faq from "../pages/Cms/Faq";
import PrivacyPolicy from "../pages/Cms/PrivacyPolicy";
import TermsConditions from "../pages/Cms/TermsConditions";
import CreateGame from "../pages/CreateGame/CreateGame";
import About from "../pages/Cms/About";
import ContactUs from "../pages/Cms/ContactUs";
import MyAccount from "../pages/Cms/MyAccount";
import OpenLayout from "../layouts/Open";
import PackageList from "../pages/Package/PackageList";
import PurchaseHistory from "../pages/Package/PurchaseHistory";
import GameList from "../pages/Game/List/GameList";
import GameBoard from "../pages/GameBoard/GameBoard";
import GameLayout from "../layouts/Game";
import GameAnswer from "../pages/GameScreen/GameAnswer";
import Game1000Question from "../pages/GameScreen/Game1000Question";
import GameBackfireAnswer from "../pages/GameScreen/GameBackfireAnswer";
import GameMysteryQuestion from "../pages/GameScreen/GameMysteryQuestion";
import GameResult from "../pages/GameScreen/GameResult";
import LeaderBoard from "../pages/GameBoard/LeaderBoard";
import GameHistory from "../pages/Game/History/GameHistory";
import MyAchievements from "../pages/MyAchievements/MyAchievements";
import Invite from "../pages/Invite/Invite";
import VerifyEmailPage from "../pages/Auth/VerifyEmailPage";
import QrCodePage from "../pages/QrCode/QrCode";
import VerifyEmailUpdatePage from "../pages/Auth/VerifyEmailUpdatePage";
import ResetPasswordPage from "../pages/Auth/ResetPasswordPage";
import PaymentResponse from "../pages/PaymentResponse/PaymentResponse";
import Notifications from "../pages/Notification/Notifications";
import NotificationDetail from "../pages/Notification/NotificationDetail";

export const AppRouter = () => {
  const router = createBrowserRouter([
    {
      path: "/payment-response",
      element: <PaymentResponse />,
    },
    {
      path: "/",
      element: <AuthLayout />,
      children: [
        {
          path: "/",
          element: <Home />,
        },
      ],
    },
    {
      path: "/",
      element: <OpenLayout />,
      children: [
        {
          path: "/leaderboard",
          element: <LeaderBoard />,
        },
        {
          path: "/faq",
          element: <Faq />,
        },
        {
          path: "/privacy-policy",
          element: <PrivacyPolicy />,
        },
        {
          path: "/terms-conditions",
          element: <TermsConditions />,
        },
        {
          path: "/about",
          element: <About />,
        },
        {
          path: "/contact-us",
          element: <ContactUs />,
        },
        {
          path: "/invite",
          element: <Invite />,
        },
        {
          path: "/verify-email",
          element: <VerifyEmailPage />,
        },
        {
          path: "/verify-email-update",
          element: <VerifyEmailUpdatePage />,
        },
        {
          path: "/reset-password",
          element: <ResetPasswordPage />,
        },
        {
          path: "/qr",
          element: <QrCodePage />,
        },
      ],
    },
    {
      path: "/",
      element: <MainLayout />,
      children: [
        {
          path: "/create-game",
          element: <CreateGame />,
        },
        {
          path: "/my-account",
          element: <MyAccount />,
        },
        {
          path: "/game-history",
          element: <GameHistory />,
        },
        {
          path: "/package-list",
          element: <PackageList />,
        },
        // {
        //   path: "/purchase-history",
        //   element: <PurchaseHistory />,
        // },
        {
          path: "/my-games",
          element: <GameList />,
        },
        {
          path: "/result/:gameId",
          element: <GameResult />,
        },
        {
          path: "/my-achievements",
          element: <MyAchievements />,
        },
        {
          path: "/notifications",
          element: <Notifications />,
        },
        {
          path: "/notifications/:id",
          element: <NotificationDetail />,
        },
      ],
    },
    {
      path: "/",
      element: <GameLayout />,
      children: [
        {
          path: "/game/:gameId",
          element: <GameBoard />,
        },
        {
          path: "/game/:gameId/answer/:categoryId/:questionId",
          element: <GameAnswer />,
        },
        {
          path: "/game/:gameId/1000-question",
          element: <Game1000Question />,
        },
        {
          path: "/game/:gameId/backfire-answer",
          element: <GameBackfireAnswer />,
        },
        {
          path: "/game/:gameId/mystery-question",
          element: <GameMysteryQuestion />,
        },
        {
          path: "/create-game",
          element: <CreateGame />,
        },
      ],
    },
    {
      path: "*",
      element: <PageNotFound />,
    },
  ]);

  return <RouterProvider router={router} />;
};
